import React from "react";
import { createElement } from "react";
import { calcBackgroundSize } from "../../utils";
import styles from "./Loginpage.module.css";

function SingleIcon() {
    const icons = [
        "fa-solid fa-money-bill",
        "fa-regular fa-credit-card",
        "fa-solid fa-sack-dollar",
        "fa-solid fa-wallet",
        "fa-solid fa-piggy-bank",
        "fa-solid fa-dollar-sign",
        "fa-brands fa-btc",
        "fa-brands fa-ethereum",
        "fa-brands fa-monero",
        "fa-solid fa-chart-pie",
        "fa-solid fa-chart-line",
        "fa-solid fa-file-invoice",
        "fa-solid fa-sterling-sign",
        "fa-solid fa-euro-sign",
    ];

    var i = Math.floor(Math.random() * icons.length); //selecting a random icon

    return createElement("i", { className: icons[i] });
}

function PictureRow() {
    var data = calcBackgroundSize();
    var max = data.numIconsWidth;
    const rows = [];
    for (let i = 0; i < max; i++) {
        rows.push(<SingleIcon key={i} />);
    }
    return <div className={styles.rows}>{rows}</div>;
}

export default function LoginBackground() {
    var data = calcBackgroundSize();
    var max = data.numIconsHeight;
    const cols = [];
    for (let i = 0; i < max; i++) {
        cols.push(<PictureRow key={i} />);
    }
    return <div className={styles.picrow}>{cols}</div>;
}
